// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CyJL","list":"styles_list__2-FzB","disableSelection":"styles_disableSelection__P9C4F"};